import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-header-page-ui',
    templateUrl: './bb-header-page-ui.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BbHeaderPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
